import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useMetrics(): RootState["metrics"] {

    const metrics = useSelector<RootState, RootState["metrics"]>(
        ({ metrics }) => metrics
    )

    return metrics
}
